import React from 'react';
import { useSearchParams } from 'react-router-dom';

import Login from '../account/authentication-pages/Login.jsx';
import Signup from '../account/authentication-pages/SignUp.jsx';
import AccessManagement from '../account/invitation-pages/AccessManagement.jsx';

const AccountPage = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const mode = searchParams.get('mode');

    const switchToSignUp = () => setSearchParams({ mode: 'signup' });
    const switchToLogin = () => setSearchParams({ mode: 'login' });

    if (mode === 'login') return <Login navigatedFrom='home' onSwitchToSignup={switchToSignUp} />;
    if (mode === 'signup') return <Signup navigatedFrom='home' onSwitchToLogin={switchToLogin} />;

    return <AccessManagement />;
};

export default AccountPage;